import { render } from "./good-list.vue?vue&type=template&id=45dcd7ca&scoped=true"
import script from "./good-list.vue?vue&type=script&lang=js"
export * from "./good-list.vue?vue&type=script&lang=js"

import "./good-list.vue?vue&type=style&index=0&id=45dcd7ca&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-45dcd7ca"

export default script